import api from "../../../api";

const API_URL = "/crm/projects";

// API untuk generate project code berdasarkan format number
export async function generateProjectCode() {
  const res = await api.post(`${API_URL}/generate-code`);
  return res.data;
}

// API untuk mendapatkan format number untuk project
export async function getFormatNumberForProject() {
  const res = await api.get('/crm/format-numbers/module/Project');
  return res.data;
}

// API untuk update current number setelah generate code
export async function updateFormatNumberCurrentNumber(formatNumberId, currentNumber) {
  const res = await api.put(`/crm/format-numbers/${formatNumberId}/current-number`, {
    currentNumber: currentNumber
  });
  return res.data;
}

// ✅ TAMBAHAN: API untuk mendapatkan semua projects
export async function getAllProjects() {
  const res = await api.get(API_URL);
  return res.data;
}

// ✅ TAMBAHAN: API untuk mendapatkan project by ID
export async function getProjectById(id) {
  const res = await api.get(`${API_URL}/${id}`);
  return res.data;
}

// ✅ TAMBAHAN: API untuk mendapatkan project detail by lead ID
export async function getProjectByLeadId(leadId) {
  const res = await api.get(`${API_URL}/detail/lead/${leadId}`);
  return res.data;
}

// ✅ TAMBAHAN: API untuk membuat project baru
export async function createProject(projectData) {
  const res = await api.post(API_URL, projectData);
  return res.data;
}

// ✅ TAMBAHAN: API untuk update project
export async function updateProject(id, projectData) {
  const res = await api.put(`${API_URL}/${id}`, projectData);
  return res.data;
}

// ✅ TAMBAHAN: API untuk delete project
export async function deleteProject(id) {
  const res = await api.delete(`${API_URL}/${id}`);
  return res.data;
}

// ✅ TAMBAHAN: API untuk search projects
export async function searchProjects(searchTerm) {
  const res = await api.get(`${API_URL}/search?searchTerm=${searchTerm}`);
  return res.data;
}

// ✅ TAMBAHAN: API untuk mendapatkan projects by status
export async function getProjectsByStatus(status) {
  const res = await api.get(`${API_URL}/status/${status}`);
  return res.data;
}

// ✅ TAMBAHAN: API untuk convert proposal to project
export async function convertFromProposal(proposalId, projectData) {
  const res = await api.post(`${API_URL}/convert-from-proposal/${proposalId}`, projectData);
  return res.data;
}

// ✅ TAMBAHAN: API untuk mendapatkan projects by company ID
export async function getProjectsByCompanyId(companyId) {
  const res = await api.get(`${API_URL}/company/${companyId}`);
  return res.data;
} 